import { NavLink, Link } from "react-router-dom";
import { useState } from "react";
import { Menu, X, Calendar } from "lucide-react";
import { CLINIC } from "@/lib/clinic";

const links = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/doctor", label: "Doctor" },
  { to: "/services", label: "Services" },
  { to: "/diagnostics", label: "Diagnostics" },
  { to: "/blog", label: "Health Blog" },
  { to: "/gallery", label: "Gallery" },
  { to: "/testimonials", label: "Testimonials" },
  { to: "/faqs", label: "FAQs" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  return (
    <header className="glass-nav sticky top-0 z-50" data-testid="site-navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link to="/" className="flex items-center gap-3 group" data-testid="nav-home-link">
            <div className="h-10 w-10 rounded-xl grid place-items-center text-white font-serif text-lg"
                 style={{ background: "linear-gradient(135deg,#0A6EBD,#16A5B8)" }}>A</div>
            <div className="leading-tight">
              <div className="font-serif text-xl tracking-tight text-slate-900">{CLINIC.name}</div>
              <div className="text-[10px] uppercase tracking-[0.22em] text-teal-600 font-semibold">
                Compassionate Care · Better Health
              </div>
            </div>
          </Link>

          <nav className="hidden lg:flex items-center gap-6">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g,"-")}`}
                className={({ isActive }) =>
                  `text-sm font-medium link-underline ${isActive ? "text-[#0A6EBD]" : "text-slate-700 hover:text-[#0A6EBD]"}`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/appointment"
              data-testid="nav-book-appointment-btn"
              className="inline-flex items-center gap-2 rounded-full px-4 lg:px-5 py-2.5 text-sm font-semibold text-white shadow-md hover:shadow-lg transition"
              style={{ background: "#0A6EBD" }}
            >
              <Calendar className="h-4 w-4" /> Book Appointment
            </Link>
          </div>

          <button
            className="lg:hidden inline-flex items-center justify-center h-10 w-10 rounded-lg border border-slate-200 text-slate-700"
            onClick={() => setOpen(!open)}
            data-testid="nav-mobile-toggle"
            aria-label="Toggle navigation"
          >
            {open ? <X /> : <Menu />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-slate-100 bg-white" data-testid="mobile-menu">
          <div className="px-4 py-3 flex flex-col gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `px-3 py-2.5 rounded-lg text-sm font-medium ${isActive ? "bg-blue-50 text-[#0A6EBD]" : "text-slate-700 hover:bg-slate-50"}`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/appointment"
              onClick={() => setOpen(false)}
              className="mt-2 rounded-full text-center py-3 text-white font-semibold"
              style={{ background: "#0A6EBD" }}
              data-testid="mobile-book-appointment-btn"
            >
              Book Appointment
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
